import { useState } from "react";
import MuiSwipeableDrawer from "./MuiSwipeableDrawer";
import { Box, List } from "@mui/material";
import { Home } from "@mui/icons-material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CollectionsIcon from "@mui/icons-material/Collections";
import InventoryIcon from "@mui/icons-material/Inventory";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import MainMenuWithLink from "./MainMenuWithLink";
import FactoryIcon from "@mui/icons-material/Factory";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import ClosedCaptionOffIcon from "@mui/icons-material/ClosedCaptionOff";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import OutboundIcon from "@mui/icons-material/Outbound";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Looks3Icon from "@mui/icons-material/Looks3";
import ReviewsIcon from "@mui/icons-material/Reviews";
import CallMissedIcon from "@mui/icons-material/CallMissed";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PortraitIcon from "@mui/icons-material/Portrait";
import AssessmentIcon from "@mui/icons-material/Assessment";
import EventIcon from "@mui/icons-material/Event";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { NavLink } from "react-router-dom";
import { checkPageAndPagePath } from "../../../../pages/checkPagePermissions";
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/features/store/store";
import { PAGES } from "../../../../enums/PagesEnum";
import SubMenuWithLink from "./SubMenuWithLink";
import MainMenuWithoutLink from "./MainMenuWithoutLink";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RtsNoticeDialog from "../../../../pages/returnToStation/RtsNoticeDialog";


const SIDEBAR_WIDTH = 210;

type SidebarProps = {
  isOpen: boolean;
  handleDrawerClose: () => void;
  handleDrawerOpen: () => void;
};

const Sidebar = ({
  isOpen,
  handleDrawerClose,
  handleDrawerOpen,
}: SidebarProps) => {
  const pagePermissions = useSelector(
    (state: RootState) =>
      state.login?.authResponse?.userSettings?.pagePermissions
  );

  const [isManifestMenuListOpen, setIsManifestMenuListOpen] = useState(false);
  const [isRtsNoticeDialogOpen, setIsRtsNoticeDialogOpen] = useState(false);

  return (
    <MuiSwipeableDrawer
      isOpen={isOpen}
      handleDrawerClose={handleDrawerClose}
      handleDrawerOpen={handleDrawerOpen}
    >
      <Box sx={{ minWidth: SIDEBAR_WIDTH }} role="presentation">
        <List>
          {/* Home */}
          <NavLink
            to="/home"
            key="home"
            style={{ textDecoration: "none", color: "white" }}
          >
            <MainMenuWithLink
              handleMainMenuWithLinkOnClick={handleDrawerClose}
              menuName="Home"
              pathName="/"
            >
              <Home sx={{ width: 20, height: 20 }} />
            </MainMenuWithLink>
          </NavLink>

          {/* Zip Coverage */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.ZIP_COVERAGE
            ) && (
              <NavLink
                to="/zipCoverage"
                key="zipCoverage"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Zip Coverage"
                  pathName="/zipCoverage"
                >
                  <EventNoteIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Clients */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(pagePermissions, undefined, PAGES.CLIENTS) && (
              <NavLink
                to="/clients"
                key="clients"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Clients"
                  pathName="/clients"
                >
                  <FactoryIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Parcel Centers */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.PARCEL_CENTERS
            ) && (
              <NavLink
                to="/parcelCenters"
                key="parcelCenters"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Parcel Centers"
                  pathName="/parcelCenters"
                >
                  <FactoryIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* FDP */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(pagePermissions, undefined, PAGES.FDP) && (
              <NavLink
                to="/fdp"
                key="fdp"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="FDP"
                  pathName="/fdp"
                >
                  <GroupWorkIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* FDP Zipcode */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.FDP_ZIPCODE
            ) && (
              <NavLink
                to="/fdpZipcode"
                key="fdpZipcode"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="FDP Zipcode"
                  pathName="/fdpZipcode"
                >
                  <ClosedCaptionOffIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* GC Import */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.GC_IMPORT
            ) && (
              <NavLink
                to="/gcImport"
                key="gcImport"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="GC Import"
                  pathName="/gcImport"
                >
                  <ImportContactsIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Shipments */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.SHIPMENTS
            ) && (
              <NavLink
                to="/shipments"
                key="shipments"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Shipments"
                  pathName="/shipments"
                >
                  <AirportShuttleIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Packages */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.PACKAGES
            ) && (
              <NavLink
                to="/packages"
                key="packages"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Packages"
                  pathName="/packages"
                >
                  <ShoppingBagIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Out Of Area */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.OUT_OF_AREA
            ) && (
              <NavLink
                to="/outOfArea"
                key="outOfArea"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Out Of Area"
                  pathName="/outOfArea"
                >
                  <OutboundIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Packages Arrived */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.PACKAGES_ARRIVED
            ) && (
              <NavLink
                to="/packagesArrived"
                key="packagesArrived"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Packages Arrived"
                  pathName="/packagesArrived"
                >
                  <ArrowBackIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Packages For Review */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.PACKAGES_FOR_REVIEW
            ) && (
              <NavLink
                to="/packagesForReview"
                key="packagesForReview"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Packages For Review"
                  pathName="/packagesForReview"
                >
                  <ReviewsIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Max Attempts */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.MAX_ATTEMPT
            ) && (
              <NavLink
                to="/maxAttempts"
                key="maxAttempts"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Max Attempts"
                  pathName="/maxAttempts"
                >
                  <Looks3Icon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Missing Manifest */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.MISSING_MANIFEST
            ) && (
              <NavLink
                to="/missingManifest"
                key="missingManifest"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Missing Manifest"
                  pathName="/missingManifest"
                >
                  <CallMissedIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* User */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(pagePermissions, undefined, PAGES.USER) && (
              <NavLink
                to="/user"
                key="user"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="User"
                  pathName="/user"
                >
                  <PersonAddIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Role */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(pagePermissions, undefined, PAGES.ROLE) && (
              <NavLink
                to="/role"
                key="role"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Role"
                  pathName="/role"
                >
                  <PortraitIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Route Report */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.ROUTE_REPORT
            ) && (
              <NavLink
                to="/routeReport"
                key="routeReport"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Route Report"
                  pathName="/routeReport"
                >
                  <AssessmentIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Middle Mile */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.MIDDLE_MILE
            ) && (
              <NavLink
                to="/middleMile"
                key="middleMile"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Middle Mile"
                  pathName="/middleMile"
                >
                  <InventoryIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Receiving */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            (checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.PC_MANIFEST
            ) ||
              checkPageAndPagePath(
                pagePermissions,
                undefined,
                PAGES.STORE_MANIFEST
              )) && (
              <>
                <MainMenuWithoutLink
                  handleMainMenuWithoutLinkOnClick={() =>
                    setIsManifestMenuListOpen(!isManifestMenuListOpen)
                  }
                  menuName="Manifest"
                  isMainMenuWithoutLinkOpen={isManifestMenuListOpen}
                >
                  <CollectionsIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithoutLink>
                {isManifestMenuListOpen && (
                  <List>
                    {checkPageAndPagePath(
                      pagePermissions,
                      undefined,
                      PAGES.STORE_MANIFEST
                    ) && (
                        <NavLink
                          to="/manifest-store-selection"
                          key="manifest-store-selection"
                          style={{ textDecoration: "none", color: "white" }}
                        >
                          <SubMenuWithLink
                            handleSubMenuWithLinkOnClick={handleDrawerClose} // Define your submenu click handler
                            menuName="Store Manifest"
                            pathName="/manifest-store-selection"
                          >
                            <CollectionsIcon sx={{ width: 20, height: 20 }} />
                          </SubMenuWithLink>
                        </NavLink>
                      )}
                    {checkPageAndPagePath(
                      pagePermissions,
                      undefined,
                      PAGES.PC_MANIFEST
                    ) && (
                        <NavLink
                          to="/manifest-pc-selection"
                          key="manifest-pc-selection"
                          style={{ textDecoration: "none", color: "white" }}
                        >
                          <SubMenuWithLink
                            handleSubMenuWithLinkOnClick={handleDrawerClose} // Define your submenu click handler
                            menuName="Parcel Center Manifest"
                            pathName="/manifest-pc-selection"
                          >
                            <CollectionsIcon sx={{ width: 20, height: 20 }} />
                          </SubMenuWithLink>
                        </NavLink>
                      )}
                  </List>
                )}
              </>
            )}

          {/* Return To Station */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.RETURN_TO_STATION
            ) && (
              <NavLink
                to="/returnToStation"
                key="returnToStation"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Return To Station"
                  pathName="/returnToStation"
                >
                  <AssignmentReturnIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}
          {/* ADD RTS */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.ADD_RETURN_TO_STATION
            ) && (
              <MainMenuWithLink
                handleMainMenuWithLinkOnClick={() => setIsRtsNoticeDialogOpen(true)}
                menuName="Add RTS"
                pathName=""
              >
                <AssignmentReturnIcon sx={{ width: 20, height: 20 }} />
              </MainMenuWithLink>
            )}
          {isRtsNoticeDialogOpen && (
            <RtsNoticeDialog
              isOpen={isRtsNoticeDialogOpen}
              onClose={() => setIsRtsNoticeDialogOpen(false)}
            />
          )}
          {/* Event Type */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.EVENT_TYPE
            ) && (
              <NavLink
                to="/eventType"
                key="eventType"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Event Type"
                  pathName="/eventType"
                >
                  <EventIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Vehicle Load Scan */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.VEHICLE_LOAD_SCAN
            ) && (
              <NavLink
                to="/vehicleLoadScan"
                key="vehicleLoadScan"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Vehicle Load Scan"
                  pathName="/vehicleLoadScan"
                >
                  <LocalShippingIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}

          {/* Dedicated Delivery */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.DEDICATED_DELIVERY
            ) && (
              <NavLink
                to="/dedicated-delivery"
                key="dedicated-delivery"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Dedicated Delivery"
                  pathName="/dedicated-delivery"
                >
                  <LocalShippingIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}
          {/* Route Progress - Dedicated */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.ROUTE_PROGRESS_DEDICATED
            ) && (
              <NavLink
                to="/route-progress-dedicated"
                key="route-progress-dedicated"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Route Progress - Dedicated"
                  pathName="/route-progress-dedicated"
                >
                  <LocalShippingIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}
          {/* SFTP */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(pagePermissions, undefined, PAGES.SFTP) && (
              <NavLink
                to="/sftp"
                key="sftp"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="SFTP"
                  pathName="/sftp"
                >
                  <LocalShippingIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}
          {/* Invoices */}
          {pagePermissions &&
            pagePermissions.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.INVOICE_LIST
            ) && (
              <NavLink
                to="/invoices"
                key="invoice"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Invoice"
                  pathName="/invoices"
                >
                  <ReceiptIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}
          {/* Beans Integration */}
          {pagePermissions &&
  pagePermissions?.length > 0 &&
  checkPageAndPagePath(
    pagePermissions,
    undefined,
    PAGES.BEANS_INTEGRATION
  ) && (
    <NavLink
      to="/beans-integration"
      key="beansIntegration"
      style={{ textDecoration: "none", color: "white" }}
    >
      <MainMenuWithLink
        handleMainMenuWithLinkOnClick={handleDrawerClose}
        menuName="Beans Integration"
        pathName="/beans-integration"
      >
        <ReceiptIcon sx={{ width: 20, height: 20 }} />
      </MainMenuWithLink>
    </NavLink>
  )}
          {/* Knowledge Hub */}
          {pagePermissions &&
            pagePermissions?.length > 0 &&
            checkPageAndPagePath(
              pagePermissions,
              undefined,
              PAGES.KNOWLEDGE_HUB
            ) && (
              <NavLink
                to="/knowledge-hub"
                key="knowladgeHub"
                style={{ textDecoration: "none", color: "white" }}
              >
                <MainMenuWithLink
                  handleMainMenuWithLinkOnClick={handleDrawerClose}
                  menuName="Knowledge Hub"
                  pathName="/knowledge-hub"
                >
                  <ReceiptIcon sx={{ width: 20, height: 20 }} />
                </MainMenuWithLink>
              </NavLink>
            )}
        </List>
      </Box>
    </MuiSwipeableDrawer>
  );
};

export default Sidebar;
